import { combineReducers } from 'redux';

import tunnelsReducer from './ducks/tunnels';

const reducers = combineReducers({
  table: tunnelsReducer,
});

export default reducers;
